<template>
    <div class="card-body" style="background-color:#fff;">
        <b-card no-body>
          <b-tabs card >
            <b-tab title="1:1 문의" active>
              <b-card-text>
                <table class="table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <td style="text-align:center">분류</td>
                      <td style="text-align:center">제목</td>
                      <td style="text-align:center">상태</td>
                      <td style="text-align:center">등록일</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-show="userBoardList.length==0" class="text-center"><td colspan="4">No matching records</td> </tr>
                    <tr v-show="userBoardList.length!=0" v-for="(item, index) in userBoardList" :key="index">
                      <td class="align-middle text-center">{{item.boardCatName}}</td>
                      <td class="align-middle text-center">{{item.title}}</td>
                      <td class="align-middle text-center">{{item.answer ? '답변 완료' : '답변 미완료'}}</td>
                      <td class="align-middle text-center">{{item.regDt}}</td>
                    </tr>
                  </tbody>
                </table>
              </b-card-text>
            </b-tab>
            <b-tab title="구매 내역">
              <b-card-text>준비 중 입니다.</b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
    </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api';

export default {
    props: {
        userBoardList: {
            type: Array,
            default : () => []
        },
    },
    setup(props, context) {

        return {
            ...actions(props, context)
        }
    }
}

function actions(props, context) {

    return {

    }
}
</script>